var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5C1 12.5 0 12.5 0 11.5C0 10.5 1 7.5 6 7.5C11 7.5 12 10.5 12 11.5C12 12.5 11 12.5 11 12.5H1ZM6 6.5C6.79565 6.5 7.55871 6.18393 8.12132 5.62132C8.68393 5.05871 9 4.29565 9 3.5C9 2.70435 8.68393 1.94129 8.12132 1.37868C7.55871 0.816071 6.79565 0.5 6 0.5C5.20435 0.5 4.44129 0.816071 3.87868 1.37868C3.31607 1.94129 3 2.70435 3 3.5C3 4.29565 3.31607 5.05871 3.87868 5.62132C4.44129 6.18393 5.20435 6.5 6 6.5Z",
    fill: "#FA9600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.09184b5f00a0d1f2ff1afdde9b03708f.svg";
export { ForwardRef as ReactComponent };